import { defineMessages } from 'react-intl';

const scope = 'app.workspace';

export default defineMessages({
  ok: {
    id: `${scope}.notificationErrorMessage`,
    defaultMessage: 'OK',
  },
});